<section class="header">
  <div class="header_content">
    <div><a [routerLink]="['/']">
        <img class="header_logo" [src]="'assets/images/logo/resy_logo.png'" [alt]="'Resy logo'" />
        <img class="hide_mobile_wide ms-4" [src]="'assets/images/logo/resy_logo_txt.png'" [alt]="'Resy logo'" />
      </a></div>
    <div class="header_user user">
      <div class="div_products">
        <div class="products_dropdown" (click)="menu_products.toggle($event)">
          <i class="pi c-icons-white menu-icon"></i>
        </div>
      </div>
      <div>
        <div style="position: relative; cursor: pointer;" (click)="toggleShowNotification($event)" id="icon" #icon
          pBadge [value]="badgeValue" severity="danger" class="notif_bagde">
          <img [src]="'assets/icons/notifications_24px.svg'" [alt]="'Notifications'" />
        </div>
      </div>
      <div class="user_info ms-3">
        <div class="user_name">{{ firstNameLastName }}</div>
      </div>
      <div class="dropdown">
        <div class="user_image dropbtn">
          <div (click)="menu_user.toggle($event);" id="img_toggle" #img_toggle>
            <img [src]="imagePath" alt="profile-picture" style="cursor: pointer;">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-container>
  <p-overlayPanel #menu_products styleClass="products-menu" id="menu_products" [appendTo]="menu_products" (onShow)="op.hide()"
    (onHide)="onHideProfileInfo()" [dismissable]="true">
    <div (click)="$event.stopPropagation()">
      <ng-container *ngIf="productList.length > 0">
        <div class="products-container">
          <div *ngFor="let product of productList" class="div-card-product cursor-pointer" (click)="goToProductUrl(product.url)">
            <div class="d-flex flex-wrap justify-content-center logo-container">
              <img class="product-logo" [src]="product.pictureUrl" alt="profile-picture">
            </div>
          </div>
        </div>
      </ng-container>
      <div class="p-menuitem-link" (click)="goToDashboard();">{{'HEADER.GO_TO_DASHBOARD' | translate}}</div>
    </div>
  </p-overlayPanel>
</ng-container>
<ng-container>
  <p-overlayPanel #op [styleClass]="'pos_overlay_panel'" [appendTo]="icon" (onHide)="onHideNotifications()"
    (onShow)="onShowNotifications()" [dismissable]="false">
    <div (click)="$event.stopPropagation()">
      <div class="d-flex flex-row justify-content-between mb-1" (click)="$event.stopPropagation()">
        <span class="overlay-title">{{'HEADER.NOTIFICATIONS' | translate}}</span>
        <button type="button" class="mark-as-read-btn" (click)="viewAllNotifications()">{{'HEADER.MARK_AS_READ' |
          translate}}?
        </button>
      </div>
      <div class="small_spinner_wrapper notif-spinner" *ngIf="spinner && paginationHelperModel.PageNumber === 1">
        <p-progressSpinner class="w-100 text-center pos_spinner_small"></p-progressSpinner>
      </div>
      <div class="overlay-reservations" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1"
        (scrolled)="loadMoreReservations()" [scrollWindow]="false" *ngIf="reservationList.length > 0">
        <ng-container *ngIf="newNotifications">
          <div class="d-flex flex-row justify-content-center mb-2">
            <span class="pi pi-refresh" (click)="refreshReservations()"></span>
          </div>
        </ng-container>
        <div *ngFor="let reservation of reservationList">
          <div class="d-flex flex-row justify-content-between" style="align-items: center;">
            <div class="d-flex flex-column" [class.muted-text]="reservation.seenByuser"
              (click)="openReservationDetailsPopup(reservation)">
              <span class="">{{reservation.reservationUserName}}
                {{'HEADER.NOTIFICATION_MESSAGE_1' | translate}} {{reservation.reservationNumberOfGuest}}
                {{'HEADER.NOTIFICATION_MESSAGE_2' | translate}}.
              </span>
              <span>{{reservation.timeElapsed}}</span>
            </div>
            <div class="d-flex align-items-center" style="width: 30px;">
              <ng-container *ngIf="!reservation.seenByuser">
                <p-checkbox styleClass="notification-checkbox" name="markAsRead" [value]="reservation.id"
                  (onChange)="viewNotification(reservation.id)"></p-checkbox>
                <i class="custom-checkbox-icon pi pi-check"></i>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-overlayPanel>
</ng-container>
<ng-container>
  <p-overlayPanel #menu_user styleClass="edit-menu" id="user_menu" [appendTo]="img_toggle" (onShow)="op.hide()"
    (onHide)="onHideProfileInfo()" [dismissable]="true">
    <div (click)="$event.stopPropagation()">
      <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
        #openFile accept="image/png, image/jpg, image/jpeg" (click)="openFile.value = ''" />
      <div class="menu_img mb-3">
        <div>
          <span>
            <div class="menu_dropdown_helper pe-0 pt-0" #icon_1 (click)="menu.toggle($event)"></div>
            <img (click)="icon_1.click()" alt="" [src]="imagePath" class="mb-3" style="cursor: pointer;">
            <p-menu #menu class="venues-menu img-menu" [popup]="true" [model]="items"></p-menu>
          </span>
        </div>
        <label *ngIf="pictureIsWrongFormat" class="align-top">
          <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
            pTooltip="{{'VENUE.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
        </label>
        <div class="menu_txt_large">{{firstNameLastName}}</div>
        <div class="menu_txt_small">{{email}}</div>
      </div>
      <div class="p-menuitem-link" (click)="logOut();">{{'HEADER.LOGOUT' | translate}}</div>
    </div>
  </p-overlayPanel>
</ng-container>
